import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { LoaderService } from './../services/loader.service';
import { AuthService } from './auth.service';
import { UserManageInfo } from './../models/userManageInfo';

import { SpinnerComponent } from './../shared/spinner.component';

@Injectable()
export class ConfigService {

  public versionApp: string;
  public pathWebApi: string;
  public bloccoSeqTipoCartaDefault: number = appConfig.bloccoSeqTipoCartaDefault;

  constructor() {
  }
}


@Injectable()
export class HttpService {

  constructor(private authService: AuthService, private loadService: LoaderService, private http: HttpClient, private route: Router, public configService: ConfigService) {
  }

  get(url, options?: any) {

    this.loadService.showSpinner();

    if (!options)
      options = {};
    options.headers = this.getCustomHeaders();

    return this.http.get(this.configService.pathWebApi + url, options)
      .map((res: any) => { return this.handleResponse(res); })
      .catch(err => { return this.handleError(err) })
      .finally(() => {
        this.loadService.hideSpinner();
      });
  }

  post(url, postBody: any, options?: any) {
    this.loadService.showProgressBar();

    if (!options)
      options = {};
    options.headers = this.getCustomHeaders();

    return this.http.post(this.configService.pathWebApi + url, postBody, options)
      .map((res: any) => { return this.handleResponse(res); })
      .catch(err => { return this.handleError(err) })
      .finally(() => {
        this.loadService.hideProgressBar();
      });
  }

  put(url, postBody: any, options?: any) {
    this.loadService.showSpinner();

    if (!options)
      options = {};
    options.headers = this.getCustomHeaders();

    return this.http.put(this.configService.pathWebApi + url, postBody, options)
      .map((res: any) => { return this.handleResponse(res); })
      .catch(err => { return this.handleError(err) })
      .finally(() => {
        this.loadService.hideSpinner();
      });
  }

  delete(url, options?: any) {
    this.loadService.showSpinner();

    if (!options)
      options = {};
    options.headers = this.getCustomHeaders();

    return this.http.delete(this.configService.pathWebApi + url, options)
      .map((res: any) => { return this.handleResponse(res); })
      .catch(err => { return this.handleError(err) })
      .finally(() => {
        this.loadService.hideSpinner();
      });
  }

  public uploadFile(fileBody: any, options?: any) {
    this.loadService.showProgressBar();

    if (!options)
      options = {};
    options.headers = new HttpHeaders({
      'Authorization': 'bearer ' + this.authService.getToken()
    });
    options.responseType = 'text/html';

    const formData: FormData = new FormData();
    formData.append('fileKey', fileBody, fileBody.name);
    return this.http
      .post('upload/uploadhandler.ashx', formData, options)
      .map((res: any) => { return this.handleResponse(res); })
      .catch(err => { return this.handleError(err) })
      .finally(() => {
        this.loadService.hideProgressBar();
      });
  }

  handleResponse(res: any): any {
    return res;
  }

  handleError(error: any): Observable<any> {
    if (error.status == 401) {
      this.authService.logout().subscribe(
        success => { return null; },
        err => { return Observable.throw(error); }
      );
    }
    else {
      var detailError = null;
      if (error.error && error.error.message && !error.error.data)
        detailError = { message: error.error.message, code: error.error.code };
      else if (error.error && error.error.data && error.error.data.Message) //Message grande
        detailError = { message: error.error.data.Message, code: error.error.code };
      else if (error.error && error.error.data && error.error.data.message) //message piccolo
        detailError = { message: error.error.data.message, code: error.error.code };
      else if (error.error && error.error.data && typeof error.error.data === 'string')
        detailError = { message: error.error.data, code: error.error.code };
      else if (error.error && error.error.data && typeof error.error.data === 'object')
        detailError = { message: error.error.message, data: error.error.data, code: error.error.code };

      if (detailError != null)
        error.customError = detailError;
      console.log(error);
      return Observable.throw(error);
    }
  }


  getToken(): any {
    return this.authService.getToken();
  }

  setToken(token: string): void {
    this.authService.setToken(token);
  }


  private getCustomHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'bearer ' + this.authService.getToken() });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/app.service.ts